<template>
  <div class="search-wrap">
    <common-bg-plate>
      <change-chain></change-chain>
      <div class="user-content">
        <ciphertext-retrieval ref="ciphertextRetrieval"></ciphertext-retrieval>
      </div>
    </common-bg-plate>
  </div>
</template>
<script>
import changeChain from '../privacyComputing/components/changeChain.vue'
import ciphertextRetrieval from '../blockchain/ciphertextRetrieval/index'
export default {
  components: {
    changeChain,
    ciphertextRetrieval
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('search-wrap', (), ());
.search-wrap {
  @include adaptation(
    (
      --search-wrap-user-content-padding: 24px 20px
    )
  );
  --search-wrap-min-height: var(--base-main-router-body-avaliable-height);
  .common-bg-plate {
    min-height: var(--search-wrap-min-height);
    .user-content {
      padding: var(--search-wrap-user-content-padding);
    }
  }
}
</style>
